export default __webpack_public_path__ + "static/media/helpAlarmData.0abc1be7.png";